var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"centered":"","title":"Delete xTend"},on:{"ok":_vm.deleteXtend}},[_vm._v(" Are you sure you want to delete this xTend? You cannot undo this action. ")])}
var staticRenderFns = []

export { render, staticRenderFns }